import React from 'react'
import { object } from 'prop-types'
import { graphql } from 'gatsby'

import Category from '@/components/Category'
import SEO from '@/components/SEO'
import mediaQueries from '@/layout/media-queries'
import EnhancedListProvider from '@/context/EnhancedList'
import {
  checkIfCompatibilityExcluded,
  getStaticAppsList,
} from '@/utils/products'
import { SORT, FILTERS, SECTIONS } from '@/constants'
import Layout from '@/layout'

const overrideStyles = {
  container: {
    marginBottom: '60px',

    [mediaQueries.smallScreen()]: {
      marginBottom: '0px',
    },
  },
}

const productLabel = process.env.GATSBY_PRODUCT_LABEL
const sortOptions = Object.values(SORT)

const AiPowered = ({ data: { allApp, allFeedback } }) => {
  const allAppNodes = getStaticAppsList(allApp, allFeedback)
  const defaultFilters = checkIfCompatibilityExcluded()

  const category = {
    slug: 'ai-powered',
    name: 'AI-Powered',
  }

  const supportedFilters = [
    FILTERS.CATEGORY.ID,
    FILTERS.PAYMENT.ID,
    FILTERS.WIDGET_PLACEMENT.ID,
    'sortBy',
    FILTERS.COMPATIBILITY.ID,
  ]

  return (
    <EnhancedListProvider
      items={allAppNodes}
      defaultSortValue={SORT.RECOMMENDED.VALUE}
      defaultSortOptions={sortOptions}
      defaultFilters={defaultFilters}
      supportedFilters={supportedFilters}
      section={SECTIONS.APPS}
    >
      <Layout
        overrideStyles={overrideStyles}
        headerLabel="AI-Powered Apps"
        category={category}
      >
        <Category
          allApps={allAppNodes}
          name="AI-Powered Apps"
          headline={`Extend your ${productLabel} with AI-Powered Apps - work smarter, not harder.`}
          hasCategoryFilter={false}
          filtersOpenOnInit
        />
      </Layout>
    </EnhancedListProvider>
  )
}

AiPowered.propTypes = {
  data: object,
}

export default AiPowered

export const Head = () => (
  <SEO
    title={`Enhance ${productLabel} with AI-Powered Apps | ${productLabel}`}
    description={`Extend your ${productLabel} with AI-Powered Apps to work smarter, not harder.`}
    path="/apps/ai-powered/"
  />
)

export const query = graphql`
  query {
    allApp(filter: { customProps: { isAiPowered: { eq: "true" } } }) {
      nodes {
        logo {
          ...ProductLogo
        }
        id
        slug
        name
        hidden
        underMaintenance
        product
        installations
        shortDescription
        longDescription
        tutorialUrl
        publishedAt
        category {
          id
          name
          slug
        }
        icons {
          id
          large
          original
          small
          title
        }
        customProps {
          appVideoUrl
          hiddenForBeta
          isService
          usingBeta
          categoryOrder
          isPremium
          isAiPowered
          order
        }
        payment {
          price
          frequency
          trialDays
          perAccount
        }
        widgets {
          id
          placement
        }
      }
    }

    allFeedback {
      nodes {
        id
        rate
        product
      }
    }
  }
`
